/* JSW Sports Shopify Theme - Main JS */
document.addEventListener('DOMContentLoaded', function () {

  // Cart count update
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.js-cart-count').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function() {});
  }
  updateCartCount();

  // Add to cart buttons
  document.querySelectorAll('.js-atc').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const id = this.dataset.variantId;
      if (!id) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        updateCartCount();
        const orig = this.textContent;
        this.textContent = '✓ Added';
        this.style.background = 'var(--lime)';
        setTimeout(() => {
          this.textContent = orig;
          this.style.background = '';
        }, 1500);
      });
    });
  });

  // Product page thumbnail switcher
  document.querySelectorAll('.js-thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const mainImg = document.querySelector('.js-main-image');
      if (mainImg) mainImg.src = this.dataset.src;
      document.querySelectorAll('.js-thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Variant selector
  document.querySelectorAll('.js-variant-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.js-variant-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const atcBtn = document.querySelector('.js-atc');
      if (atcBtn) atcBtn.dataset.variantId = this.dataset.variantId;
    });
  });

  // Sticky header shadow on scroll
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 24px rgba(26,54,68,0.15)'
        : '0 2px 16px rgba(26,54,68,0.08)';
    });
  }

  // ── MOBILE NAV ────────────────────────────────────────
  // NOTE: All burger/drawer/accordion logic lives in sections/header.liquid
  // to keep it co-located with the HTML. theme.js does NOT handle nav open/close.

  // ── PRODUCT CARD IMAGE SLIDESHOW ──────────────────────
  function initCardSlideshows() {
    document.querySelectorAll('.product-card__slideshow').forEach(function(slideshow) {
      var count = parseInt(slideshow.dataset.imageCount, 10);
      if (count <= 1) return;

      var slides = slideshow.querySelectorAll('.product-card__slide');
      var dots = slideshow.querySelectorAll('.product-card__slide-dot');
      var current = 0;
      var timer = null;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = index % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function startSlideshow() {
        timer = setInterval(function() {
          goTo(current + 1);
        }, 2000);
      }

      function stopSlideshow() {
        clearInterval(timer);
        goTo(0); // reset to first image on mouse leave
      }

      slideshow.closest('.product-card__image-wrap').addEventListener('mouseenter', startSlideshow);
      slideshow.closest('.product-card__image-wrap').addEventListener('mouseleave', stopSlideshow);
    });
  }

  initCardSlideshows();

  // Re-init after any dynamic content loads (e.g. infinite scroll)
  document.addEventListener('collection:reloaded', initCardSlideshows);

});